export const MAX_UPLOAD_FILES = 5;
export const FAKE_PROGRESS_DURATION_MS = 5000;
export const FAKE_PROGRESS_TICK_MS = 100;
export const UPLOAD_FOOTER_AUTO_DISMISS_MS = 2000;
export const UPLOAD_FOOTER_EXIT_ANIMATION_MS = 300;
export const AUTO_CLOSE_SINGLE_SUCCESS_MS = 2000;
